module.exports = __webpack_public_path__ + "static/img/QuantData2.9a62c66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/QuantData2.png
// module id = 9uwL
// module chunks = 3